import _ from "lodash";
import { ListingProps } from "types/listing";
import { LabelValuePair } from "utilities/objects";

export const querystring = (props?: ListingProps) => {
  const orderKey = props?.sortKey ? `_orderBy[${props?.sortKey}]` : undefined;
  const params = {
    _page: props?.page,
    _itemsOnPage: props?.rows,
  } as any;

  if (orderKey) params[orderKey] = props?.order;

  const paramsString = Object.keys(JSON.parse(JSON.stringify(params)))
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join("&");

  const parseFilterValue = (value: any) => {
    if (typeof value === "object") {
      if (_.isArray(value)) {
        return value
          .map((filter) =>
            typeof filter === "string" ? filter : filter.value || filter.id,
          )
          .join();
      } else {
        if ("filterPopupValue" in value) {
          return value.filterPopupValue;
        }
        return value.label;
      }
    } else {
      return Array.isArray(value)
        ? value
            ?.map((item: LabelValuePair | string) =>
              typeof item === "string" ? item : item.value,
            )
            .join()
        : value;
    }
  };

  const filterString = props?.filters
    ?.map((filter) => {
      return `${encodeURIComponent(filter.query)}${
        filter.condition ? `[${encodeURIComponent(filter.condition)}]` : ""
      }=${encodeURIComponent(parseFilterValue(filter.value))}`;
    })
    .join("&");

  const dynamiSearchString = props?.dynamicSearch?.value
    ? `${encodeURIComponent(props.dynamicSearch.query)}[like]=${props.dynamicSearch.value}`
    : "";

  const queryString = [paramsString, filterString, dynamiSearchString]
    .filter((item) => item)
    .join("&");

  return queryString ? `?${queryString}` : "";
};
